import { render } from "./Quote.vue?vue&type=template&id=69974576&scoped=true&ts=true"
import script from "./Quote.vue?vue&type=script&lang=ts"
export * from "./Quote.vue?vue&type=script&lang=ts"

import "./Quote.vue?vue&type=style&index=0&id=69974576&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69974576"]])

export default __exports__